module.exports = __webpack_public_path__ + "img/familymart_logo.38b60a29.svg";